import { SerializableObject } from '../../common-react/core';

import { Currency } from '../other/currency.type';

// DTO Object for representing insurance information when register shipment with insurance
export class InsuranceInfo extends SerializableObject {
  // The amount to insure for
  public amount: number;

  // The currency of the amount
  public currency: Currency;
}
